import { Link, NavLink, useLocation } from "react-router-dom";
import { Ticket, ScanLine, LayoutDashboard, Search } from "lucide-react";
import { useAuth } from "../lib/auth";
import { FOOTER_GROUPS } from "../content/legalPages";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const isPortaria = loc.pathname.startsWith("/portaria");

  return (
    <div className="min-h-screen">
      <header className="glass sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-logo">
            <span className="w-2.5 h-2.5 rounded-full bg-[#00E676] shadow-[0_0_16px_#00E676]" />
            <span className="font-display font-extrabold text-xl tracking-tight">
              Connect<span className="text-[#00E676]">ick</span>
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-1 text-sm">
            <NavItem to="/" icon={<Ticket size={16}/>} testid="nav-eventos">Eventos</NavItem>
            <NavItem to="/meus-ingressos" icon={<Search size={16}/>} testid="nav-meus">Meus Ingressos</NavItem>
            {user?.role === "organizer" && (
              <NavItem to="/organizador" icon={<LayoutDashboard size={16}/>} testid="nav-organizador">Organizador</NavItem>
            )}
            <NavItem to="/portaria" icon={<ScanLine size={16}/>} testid="nav-portaria">Portaria</NavItem>
          </nav>
          <div className="flex items-center gap-2">
            {user ? (
              <>
                <span className="hidden sm:inline text-xs text-slate-400">{user.name}</span>
                <button onClick={logout} data-testid="logout-btn"
                        className="px-3 py-1.5 rounded-full text-xs border border-white/10 hover:border-white/30 transition">
                  Sair
                </button>
              </>
            ) : (
              !isPortaria && (
                <Link to="/login" data-testid="header-login-btn"
                      className="px-3 py-1.5 rounded-full text-xs border border-white/10 hover:border-white/30 transition">
                  Entrar
                </Link>
              )
            )}
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-5 md:px-8 py-8 md:py-12">{children}</main>
      <footer className="border-t border-white/10 py-10 mt-16 text-xs text-slate-500" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-8 text-left">
          {FOOTER_GROUPS.map((g) => (
            <div key={g.title}>
              <div className="text-[11px] uppercase tracking-widest text-slate-300 font-semibold mb-3">{g.title}</div>
              <ul className="space-y-2">
                {g.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="hover:text-[#00D8F6] transition-colors" data-testid={`footer-link-${to.slice(1)}`}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">© 2026 Connectick · Pagamentos processados por InfinitePay</div>
      </footer>
    </div>
  );
}

function NavItem({ to, icon, children, testid }) {
  return (
    <NavLink to={to} end data-testid={testid}
      className={({ isActive }) =>
        `flex items-center gap-1.5 px-3 py-2 rounded-full transition ${
          isActive ? "bg-white/10 text-white" : "text-slate-300 hover:text-white hover:bg-white/5"
        }`
      }>
      {icon}{children}
    </NavLink>
  );
}
